import { useTranslation } from "react-i18next";
import type { ActionDto } from "@audit-plan/shared";
import { ActionStatusPill, DueLabel } from "../pills";
import { ResponsiveList } from "../ResponsiveList";

export function OverdueActions({ actions, onOpen }: { actions: ActionDto[]; onOpen: (id: string) => void }) {
  const { t } = useTranslation();
  return (
    <ResponsiveList<ActionDto>
      size="small"
      rowKey="id"
      pageSize={false}
      dataSource={actions}
      emptyText={t("none")}
      onRowClick={(r) => onOpen(r.id)}
      card={{
        code: (r) => r.code,
        title: (r) => r.title,
        subtitle: (r) => r.supplierName,
        tags: (r) => (
          <>
            <ActionStatusPill a={r} />
            <DueLabel a={r} />
          </>
        ),
      }}
      columns={[
        { title: t("code"), dataIndex: "code", render: (v: string) => <span style={{ fontFamily: "var(--ap-mono)" }}>{v}</span> },
        {
          title: t("supplier"),
          render: (_: unknown, r: ActionDto) => (
            <div>
              {r.supplierName}
              <div style={{ fontSize: 12, opacity: 0.65 }}>{r.title}</div>
            </div>
          ),
        },
        { title: t("dueDate"), render: (_: unknown, r: ActionDto) => <DueLabel a={r} /> },
        { title: t("status"), render: (_: unknown, r: ActionDto) => <ActionStatusPill a={r} /> },
      ]}
    />
  );
}
